var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"loading":_vm.loading,"title":"Create Stripe Account","outlined":false},on:{"click":function($event){return _vm.submit()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }